import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useDispatch, useSelector } from 'react-redux'

import { api } from '@/lib/api-client'
import { MutationConfig } from '@/lib/react-query'
// @ts-expect-error Legacy JavaScript module has no type declarations.
import { selectFilters } from '../../Customers/customers.selectors'
import { invalidateAfterBillingRestrictionStart } from './start-billing-restriction'
import { refreshCustomersAfterStoreDelinquency } from './update-store-delinquent'

type StopBillingRestrictionInput = {
	accountId: string
}

export const stopBillingRestriction = ({ accountId }: StopBillingRestrictionInput): Promise<void> => {
	return api.post(`/BillingRestrictions/accounts/${accountId}/stop`)
}

type UseStopBillingRestrictionOptions = {
	mutationConfig?: MutationConfig<typeof stopBillingRestriction>
}

export const useStopBillingRestriction = ({ mutationConfig }: UseStopBillingRestrictionOptions = {}) => {
	const queryClient = useQueryClient()
	const dispatch = useDispatch()
	const customerFilters = useSelector(selectFilters)
	const { onSuccess, onError, ...restConfig } = mutationConfig || {}

	return useMutation({
		mutationFn: stopBillingRestriction,
		onSuccess: async (...args) => {
			await invalidateAfterBillingRestrictionStart(queryClient, args[1].accountId)
			await refreshCustomersAfterStoreDelinquency(dispatch, customerFilters)
			onSuccess?.(...args)
		},
		onError: async (...args) => {
			await invalidateAfterBillingRestrictionStart(queryClient, args[1].accountId)
			onError?.(...args)
		},
		...restConfig,
	})
}
